// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"4c0a084b","873":"67315bba","985":"ae752b3a"}[chunkId] + ".chunk.js";
};